<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <div>
                        <p class="font-weight-bold">D. SCHOLARSHIPS/TUITION ASSISTANCE/AWARDS.</p>
                    </div>
                    <b-table-simple
                        responsive
                        striped
                        hover
                        class="text-sm text-md-md"
                    >
                        <b-thead>
                            <b-tr>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr
                                v-for="(menu, j) in data"
                                :key="j"
                                class="py-2 py-md-3"
                            >
                                <b-td class="font-weight-bold">{{ menu.key }}</b-td>
                                <b-td>
                                    <span v-html="menu.value"></span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <div>
                        <p>*Students who earn a scholarship/tuition discount/award of any category should meet the
                            following criteria to maintain the award:
                            <br>
                            1)	Continuously enroll in courses each module (unless taking approved time off)
                            and
                            <br>
                            2)	Maintain a minimum attendance rate of 80% for any Module and
                            <br>
                            3)	Avoid any disciplinary action for any reason. <br>
                            Scholarships, tuition discounts and/or awards are available for students who qualify. That is
                            why continuing your studies at BAU in the Mentora ESL Program is essential, as another
                            student might have been rejected at the time of your application.
                            Therefore, if a student who was awarded any scholarship or tuition assistance withdraws from
                            the Mentora ESL Program and does not transfer into the BAU degree program, they will not
                            receive a refund of the deposit, and/or may be required to repay the award or pay an
                            Administrative Service Fee. BAU Mentora ESL Program is committed to re-use these funds for
                            students who need or earn financial assistance. If a new student wishes to transfer their SEVIS record to another institution prior to or during the initial session (3 modules), BAU will not refund any portion of their tuition deposit or fees. Additionally, the student will be required to pay an Administrative Service Fee of $1,650.
                        </p>
                    </div>
                </b-col>

                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row  justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="form.status"
                                        name="checkbox-1"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox
                                    >
                                    <p>
                                        I read and confirm that I understand the information in Section D.
                                    </p>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>


    </div>
</template>
<script>

export default {
    props:{
        studentInformation: {
            type: Object,
        }
    },
    data() {
        return {
            data: [],
            form: {},
        }
    },

    methods: {
        async next(){
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid){
                this.$emit('next',1)
            }

        },
        async getData() {
            window.scrollTo(0,0)
             this.data.push(
                 {
                     key: 'Type of Scholarship/Discount/Award \n' +
                         'Applied During Module: ',
                     value: this.studentInformation?.scholarship_name??null,
                 },
                 {
                     key: 'Start Date of Module to Which \n' +
                         'Scholarship/Discount/Award \n' +
                         'Applied: ',
                     value: this.currencyFormat(this.studentInformation?.total_discount_amount??0),
                 },
                 {
                     key: 'Amount That Will Be Applied This \n' +
                         'Module: ',
                     value: this.currencyFormat(this.studentInformation?.discount_amount??0),
                 },
                 {
                     key: 'Additional Awards Given for This \n' +
                         'Module: ',
                     value: this.currencyFormat(this.studentInformation?.additional_awards_amount??0),
                 },

             )
        },
        back(){
            this.$emit('back', -1);
        }
    },
    created() {
        this.getData()
    },
}
</script>
